import Vue from 'vue'
import moment from 'moment'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('toDecimal', function (value, digits = 2) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
  return formatter.format(value)
})

// Máscara de CNPJ numérico ou alfanumérico (12 posições alfanuméricas + 2 DV numéricos).
// Não remove letras; recompõe as 14 posições com zeros à esquerda antes de mascarar.
function maskCnpj (value) {
  if (value === null || value === undefined || value === '') {
    return value
  }
  return String(value)
    .toUpperCase()
    .padStart(14, '0')
    .replace(/^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

Vue.filter('toCnpj', function (value) {
  return maskCnpj(value)
})

Vue.filter('formatCnpj', function (value) {
  if (value === null || value === undefined) {
    return null
  }
  return maskCnpj(value)
})

Vue.filter('formatCep', function (value) {
  if (value === null) {
    return null
  } else {
    return value.toString()
      .padStart(8, '0')
      .replace(/\D/g, '')
      .replace(/^(\d{5})(\d{3})?/, '$1-$2')
  }
})

Vue.filter('formatBoolean', function (value) {
  if (value) {
    return 'Sim'
  } else {
    return 'Não'
  }
})

Vue.filter('formatMarket', function (value) {
  if (value === 'SOUTH') {
    return 'Sul'
  }
  if (value === 'SOUTHEAST') {
    return 'Sudeste'
  }
  if (value === 'NORTHEAST') {
    return 'Nordeste'
  }
  if (value === 'NORTH') {
    return 'Norte'
  }
  return value
})

Vue.filter('formatType', function (value) {
  if (value === 'DISTRIBUTOR') {
    return 'Distribuidor'
  }
  if (value === 'GENERATOR') {
    return 'Gerador'
  }
  if (value === 'TRADER') {
    return 'Trader'
  }
  if (value === 'SELF_PRODUCER') {
    return 'Auto gerador'
  }
  if (value === 'INDEPENDENT_PRODUCER') {
    return 'Produtor independente'
  }
  if (value === 'FREE_MARKET_CONSUMER') {
    return 'Mercado livre de energia'
  }
  if (value === 'SPECIAL_CONSUMER') {
    return 'Consumidor especial'
  }
  if (value === 'TRANSMITTER') {
    return 'Transmissor'
  }
  if (value === 'EXPORTER') {
    return 'Exportador'
  }
  if (value === 'IMPORTER') {
    return 'Importador'
  }
  return value
})
Vue.filter('formatEnergyType', function (value) {
  if (value === 'CONVENTIONAL') {
    return 'Convencional'
  }
  if (value === 'I0') {
    return 'Incentivada 0%'
  }
  if (value === 'I1') {
    return 'Incentivada 100%'
  }
  if (value === 'I8') {
    return 'Incentivada 80%'
  }
  if (value === 'I5') {
    return 'Incentivada 50%'
  }
  return value
})
Vue.filter('formatOperationType', function (value) {
  if (value === 'LONG') {
    return 'Compra'
  }
  if (value === 'SHORT') {
    return 'Venda'
  }
  return value
})
Vue.filter('formatOperationTypeTitle', function (value) {
  if (value === 'LONG') {
    return 'Operação de Compra'
  }
  if (value === 'SHORT') {
    return 'Operação de Venda'
  }
  if (value === 'SWAP') {
    return 'Operação de Swap'
  }
  return value
})
Vue.filter('formatDate', function (value) {
  if (value == null || value == '') return
  return moment(value).format('DD-MM-yyyy')
})
Vue.filter('formatDateTime', function (value) {
  if (value == null || value == '') return
  return moment(value).format('DD-MM-yyyy - HH:mm:ss')
})
Vue.filter('formatStatus', function (value) {
  if (value === 'CREATED') {
    return 'Proposta criada'
  }
  if (value === 'DENIED') {
    return 'Proposta rejeitada'
  }
  if (value === 'REMAKE') {
    return 'Falta Informações'
  }
  if (value === 'REVIEW') {
    return 'Analisando proposta'
  }
  if (value === 'ACCEPTED') {
    return 'Proposta aceita'
  }
  if (value === 'REJECTED') {
    return 'Proposta rejeitada'
  }
  if (value === 'DONE') {
    return 'Proposta finalizada'
  }
  return value
})
Vue.filter('formatStatusSla', function (value) {
  if (value === 'DONE') {
    return 'Finalizado'
  }
  if (value === 'WARNING') {
    return 'Atenção'
  }
  if (value === 'LATE') {
    return 'Atrasado'
  }
  return ''
})
Vue.filter('formatGuarantee', function (value) {
  if (value === 'COLLATERAL') {
    return 'Depósito Caução'
  }
  if (value === 'BANK') {
    return 'Fiança Bancária'
  }
  if (value === 'CORPORATE') {
    return 'Fiança Coorporativa'
  }
  if (value === 'INSURANCE') {
    return 'Seguro Garantia'
  }
  if (value === 'PAYMENT_REGISTER') {
    return 'Registro Contra Pagamento'
  }
  if (value === 'INSURANCE_GUARANTEE') {
    return 'Seguro Garantia'
  }
  if (value === 'UNSECURED') {
    return 'Sem Garantia'
  }
})
Vue.filter('formatTerm', function(value) {
  if (value === 'LONG') {
    return 'Long prazo'
  }
  if (value === 'SHORT') {
    return 'Curto prazo'
  }
})
Vue.filter('formatProfile', function (value) {
  if (value === 'ANALYST') {
    return 'Analista I9'
  }
  if (value === 'TRADER') {
    return 'Trader'
  }
  if (value === 'GRF') {
    return 'Grf'
  }
  if (value === 'EXECUTIVE') {
    return 'Diretoria'
  }
  if (value === 'GUARANTEE') {
    return 'Garantidor'
  }
  return value
})
Vue.filter('formatHour', function(value) {
  if (value == null || value == '') return
  var sec_num = parseInt(value, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (Math.abs(hours)   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return hours+':'+minutes+':'+seconds;
})
Vue.filter('formatPortfolioStatus', function (value) {
  if (value === 'PROCESSED') {
    return 'Ok'
  }
  if (value === 'LOADING') {
    return 'Carregando'
  }
  if (value === 'ERROR') {
    return 'Erro'
  }
  return value
})
Vue.filter('formatSectorAnalysis', function (value) {
  if (value === 1) {
    return 'Boa'
  }
  if (value === 0) {
    return 'Neutra'
  }
  if (value === -1) {
    return 'Ruim'
  }
  if (value == null) {
    return 'Sem nota'
  }
  return value
})
Vue.filter('formatArea', function (value) {
  if (value === 'REVIEW') {
    return 'Analista I9'
  }
  if (value === 'REVIEW_ACCEPTED_EXCEPTION') {
    return 'Ecom - Energisa'
  }
  if (value === 'REVIEW_ENERGISA') {
    return 'Energisa'
  }
  if (value === 'REVIEW_MANAGER_EXCEPTION') {
    return 'Gerência Ecom - Energisa'
  }
  if (value === 'CREATED_ANALYSIS') {
    return 'GRF - Energisa'
  }
  if (value === 'REVIEW_GRF') {
    return 'GRF - Energisa'
  }
  if (value === 'REVIEW_REPORT') {
    return 'Analista I9'
  }
  if (value === 'REVIEW_MANAGER_GRF') {
    return 'Gestão GRF'
  }
  if (value === 'ACCEPTED') {
    return 'Finalizada'
  }
  if (value === 'REJECTED') {
    return 'Finalizada'
  }
})
Vue.filter('formatSerasa', function (value) {
  if (value === 0) {
    return 0
  }
  if (value === null) {
    return 'Sem nota'
  }
  return value
})
Vue.filter('formatProposeStatus', function (value) {
  if (value === 'PENDING') {
    return 'Em andamento'
  }
  if (value === 'DONE') {
    return 'Finalizada'
  }
  return ' - '
})
Vue.filter('formatCreditReportStatus', function (value) {
  if (value === 'PENDING') {
    return 'Em andamento'
  }
  if (value === "EXTRACTING_PDF") {
    return "Extraindo documento anexado";
  }
  if (value === "SUMMARIZING_PDF") {
    return "Resumindo documento anexado";
  }
  if (value === "GENERATING") {
    return "Gerando relatório";
  }
  if (value === 'DONE') {
    return 'Finalizado'
  }
  if (value === 'ERROR') {
    return 'Erro'
  }
  return value
})
